export enum enModalStatus {
  initial = 'initial',
  pending = 'pendidng',
  success = 'success',
  error = 'error',
}
